import { render, staticRenderFns } from "./Disability.vue?vue&type=template&id=4ced3331&scoped=true"
import script from "./Disability.vue?vue&type=script&lang=js"
export * from "./Disability.vue?vue&type=script&lang=js"
import style0 from "./Disability.vue?vue&type=style&index=0&id=4ced3331&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced3331",
  null
  
)

export default component.exports